// A 401 is retried once with a fresh token. That retry travels through the same fetch interceptor, so if the 401
// is permanent (for example the host is not registered to a business unit) its own 401 would trigger another
// retry, and so on without end. This guard lets a request be retried only while no retry for it is in flight.
const retrying = new Set<string>();

export const authRetryKey = (method: string, url: string): string => `${method.toUpperCase()}:${url}`;

// Returns true if the caller may retry this request, false if a retry for it is already in flight.
export const beginAuthRetry = (key: string): boolean => {
  if (retrying.has(key)) {
    return false;
  }
  retrying.add(key);
  return true;
};

export const endAuthRetry = (key: string): void => {
  retrying.delete(key);
};
